import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledSticky = styled.div<{ sticky: boolean }>`
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;

    ${(props) => {
        return props.sticky
            ? css`
                  position: fixed;
              `
            : css`
                  position: static;
              `;
    }}
`;
